import cn from 'classnames';

export function DailyCardSeparator({className}: {className?: string}) {
  return <hr className={cn('hr-divider', className)} />;
}
